// Module labels are no longer hardcoded here — RolesTab fetches them live
// from GET /api/v1/roles/modules (each entry already has a `label`), so the
// catalog and its display names can't drift out of sync with the backend.

export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Deterministic badge color for a role row, since role identity (and how
// many there are) is no longer a fixed, known-in-advance set.
const BADGE_COLORS = ['info', 'success', 'warning', 'secondary', 'error', 'dark'];

export const getRoleBadgeColor = (role) => {
  if (role?.systemLevel === 'superAdmin') return 'error';
  if (role?.systemLevel === 'admin') return 'dark';
  if (!role?.id) return 'secondary';
  // Stable per-role-id hash so the same role always gets the same color
  // across renders/pages, without needing a server-assigned color field.
  let hash = 0;
  for (let i = 0; i < role.id.length; i += 1) {
    hash = (hash * 31 + role.id.charCodeAt(i)) % BADGE_COLORS.length;
  }
  return BADGE_COLORS[hash];
};
